export default "__VITE_ASSET__C2F47ECT__"